import { apiRequest } from "@/services/api-client";
import {
  UpdatePokemonSkillsInput,
  UpdatePokemonSkillsOutput,
  WebAppRoutes,
} from "types/web-app";

export const updatePokemonSkills = (input: UpdatePokemonSkillsInput) =>
  apiRequest<UpdatePokemonSkillsOutput>(
    "/" + WebAppRoutes.UPDATE_POKEMON_SKILLS,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
